import { observer } from 'mobx-react';
import React from 'react';
import { promocodeStore } from '../../store/promocodeStore';
import { localeStore } from 'src/mobx/localesStore';
import { generateRandomString } from 'src/utils/helpers';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text from '~/view/components/Text/Text';
import './style.scss';
import CustomTooltip, { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from '~/view/components/Controls/Icon/Icon';
import { Icons } from '~/assets/fonts/Icons/icons';

interface IProps {
  disabled: boolean;
}

@observer
export default class PromocodeName extends React.Component<IProps, {}> {
  clickGenerate = () => {
    promocodeStore.changePromocode({ promocode: generateRandomString() }, true);
  };

  changeName = (value: string | undefined) => {
    promocodeStore.changePromocode({ promocode: value }, true);
  };

  generatePromoCodeButton = () => {
    return !this.props.disabled ? (
      <button onClick={this.clickGenerate} className="promocode-name__button">
        {localeStore.t('generate_promocode')}
      </button>
    ) : null;
  };

  render() {
    return (
      <div className="promocode-name ">
        <Text disabled={this.props.disabled} type="block-header" text="promo_or_coupon_name_header" required />
        <div className="d-flex flex-row align-items-center mt-2 ">
          <Input
            disabled={this.props.disabled}
            value={promocodeStore.promocode.promocode}
            onChangeValue={this.changeName}
            placeholder={localeStore.t('text')}
            validation={{ isValid: promocodeStore.isValid.promocode }}
            maxLength={20}
            nextComponent={this.generatePromoCodeButton()}
            className="promocode_large_field"
            contentClassName="full-width"
          />
          {this.props.disabled && (
            <CustomTooltip position={TOOLTIP_POSITION.FIXED} message={localeStore.t('promocode_name_non_editable_err')} wrapperClassName="ml-2">
              <Icon name={Icons.Info} className="cursor-pointer color-gray2" size={24} />
            </CustomTooltip>
          )}
        </div>
      </div>
    );
  }
}
